export function removeTrailingSlash(str: string) {
  return str.length <= 1 ? str : str.replace(/\/$/, '');
}
